import React from 'react';
import { motion } from 'framer-motion';
import { Specialty, SPECIALTY_COLORS } from '../types';
import { Droplets, Heart, FlaskConical, Stethoscope, CheckCircle2 } from 'lucide-react';
interface SpecialtyCardProps {
  specialty: Specialty;
  isSelected: boolean;
  isCompleted: boolean;
  isDimmed: boolean;
  onClick: () => void;
}
export function SpecialtyCard({
  specialty,
  isSelected,
  isCompleted,
  isDimmed,
  onClick
}: SpecialtyCardProps) {
  const color = SPECIALTY_COLORS[specialty];
  const getIcon = () => {
    switch (specialty) {
      case 'Nephrologist':
        return Droplets;
      case 'Cardiologist':
        return Heart;
      case 'Endocrinologist':
        return FlaskConical;
      case 'PCP':
        return Stethoscope;
    }
  };
  const Icon = getIcon();
  return <motion.button layout onClick={onClick} disabled={isCompleted || isSelected} initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: isDimmed ? 0.4 : 1,
    scale: isSelected ? 1.05 : 1,
    y: 0
  }} whileHover={!isCompleted && !isSelected ? {
    scale: 1.02,
    y: -4
  } : {}} className={`
        relative p-6 rounded-2xl border-2 text-left flex flex-col items-center justify-center transition-all duration-300 w-full aspect-square md:aspect-auto md:h-48
        ${isSelected ? 'bg-white shadow-xl z-10' : 'bg-white shadow-sm hover:shadow-md'}
        ${isCompleted ? 'cursor-default' : 'cursor-pointer'}
      `} style={{
    borderColor: isSelected || isCompleted ? color : '#e5e7eb'
  }} data-id="element-309">
      <div className="p-4 rounded-full mb-4 transition-colors" style={{
      backgroundColor: isSelected || isCompleted ? color : `${color}15`,
      color: isSelected || isCompleted ? '#fff' : color
    }} data-id="element-310">
        <Icon size={32} data-id="element-311" />
      </div>

      <h3 className="text-lg md:text-xl font-bold text-center" style={{
      color: isSelected || isCompleted ? color : '#1A1A1A'
    }} data-id="element-312">
        {specialty}
      </h3>

      {isCompleted && <div className="absolute top-3 right-3" data-id="element-313">
          <CheckCircle2 size={24} color={color} data-id="element-314" />
        </div>}

      {isSelected && <motion.div layoutId="outline" className="absolute inset-0 border-4 rounded-2xl pointer-events-none" style={{
      borderColor: color
    }} initial={false} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} data-id="element-315" />}
    </motion.button>;
}